export default __webpack_public_path__ + "asset/img/shop-logo/3~75dab70a.png";